import React from "react";
import '../Common.scss';
import styles from './Appliance.module.scss';
import defaultImage from '../../../assets/default.png';
export default class Appliances extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const {applianceList} = pageDetails || {};
        return (    
                <>
                    <div className="page-heading">{pageDetails?.name}</div>
                        <div className={styles["appliances-details"]}>
                        {
                            <div className={styles["details-table-app"]}>
                                 <div className={styles["table-row-app"] + " "+ styles['headings']}>
                                 <div className={styles["table-cell-app"]}>
                                        {"Image"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Name"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Supplied By"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Installed By"}
                                    </div>
                                    <div className={styles["table-cell-app"] + " " + styles["description-cell"]}>
                                        {"Description"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Cutting Dimension"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Quantity"}
                                    </div>
                                    <div className={styles["table-cell-app"] + " " + styles["module-annotation-cell"]}>
                                        {"Module Annotation"}
                                    </div>
                                </div>
                                {
                                    (applianceList || []).filter((appliance: any)=> appliance.isPriceIncluded !== false).map((appliance: any)=>{
                                        let {scope, item, installationBy, applianceName, description, cuttingDimension='NA',totalCount, moduleAnnotation} = appliance;
                                        let {imageUrl} = item;

                                        return(
                                            <div className={styles["table-row-app"]}>
                                                <div className={styles["table-cell-app"]}>
                                                    <img crossOrigin="anonymous" alt="apliance"style={{paddingTop: "0px"}} src={imageUrl ? `${imageUrl.replace('https://prod.homelanestore.com','https://www.homelanestore.com')}?ver=${new Date().getTime()}` : defaultImage} width="50x" height="35px" />
                                                </div>
                                                 <div className={styles["table-cell-app"]}>
                                                    <span>{applianceName}</span>
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                    {scope}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                 {installationBy}
                                                </div>
                                                <div className={styles["table-cell-app"] + " " + styles["description-cell"]}>
                                                {`${description ? description.toString():null}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${cuttingDimension ? cuttingDimension : "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {totalCount}
                                                </div>
                                                <div className={styles["table-cell-app"] + " " + styles["module-annotation-cell"]}>
                                                {moduleAnnotation ? moduleAnnotation : "NA"}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </>         
        )
    }

}